module.exports = __webpack_public_path__ + "img/395-a290ee.png";